import React from "react";
import { renderBoldText } from "../utils/helper";
import SourceDialog from "./SourceDialog";
import { useGlobalModalContext } from "../context/GlobalModalContext";
import SentimentFlag from "./SentimentFlag";

function AnalystsReport({ analystReport }) {
  const { showModal } = useGlobalModalContext();
  const handleSourceClick = (metadata) => {
    showModal(<SourceDialog metadata={metadata} />);
  };
  return (
    <div className="bg-white p-4 text-xs ml-4">
      Work in progress
      {/* <h2 className="text-lg font-bold mb-2 text-main">ANALYSTS REPORT</h2>
        <ul className='max-h-[25vh] overflow-y-scroll'> */}
      {/* <ul>
        {analystReport?.description?.map((item, index) => (
           <li key={index} className="pb-4">
           <div
             className="text-xs border rounded p-1"
             style={{
               borderColor: "#A6A6A6",
               borderLeft: `4px solid ${
                item?.sentiment_flag?.toLowerCase() === "positive"
                  ? "#4CAF50"
                  : item?.sentiment_flag?.toLowerCase() === "negative"
                  ? "#F15A23"
                  : "#A6A6A6"
              }`,
             }}
           >
             <div>
               <SentimentFlag sentimentFlag={item.sentiment_flag} />
              {item.title && <span className="font-bold px-2">{item.title} : </span>}
             </div>
             <div className="px-2">{renderBoldText(item.text)}</div>
           <div
               className="text-right"
               style={{ cursor: "pointer" }}
               onClick={() => handleSourceClick(item.metadata)}
             >
               <u>
                 <i>Source {item.source_name}</i>
               </u>
             </div>
           </div>
         </li>
        ))}
      </ul> */}
    </div>
  );
}

export default AnalystsReport;
